<template>
  <div class="postage">
    <b-form @submit.prevent="submit">
      <b-row class="mt-2" no-gutters>
        <b-col sm="auto">
          <money
            v-model="amount"
            class="form-control form-control-sm"
            v-bind="{ precision: 0 }"
          ></money>
        </b-col>
        <b-col sm="auto">
          <b-btn
            type="submit"
            variant="primary"
            size="sm"
            :class="[{ 'w-auto': isLoading  }]"
            :disabled="isLoading"
          >
            <span v-if="isLoading">
              Purchasing
              <b-spinner small v-if="isLoading"></b-spinner>
            </span>
            <span v-else>
              Purchase
            </span>
          </b-btn>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<style lang="scss" scoped>
.postage {
  input {
    font-size: 12px;
    padding: 0 8px !important;
    height: 20px;
    margin-right: 6px;
    width: 90px;
  }
  button {
    width: 90px;
    background-color: #4da030;
    border-color: #4da030;
    color: white;
  }
}
</style>

<script>
import { mapActions } from 'vuex';
export default {
  data() {
    return {
      isLoading: false,
      amount: 0,
    };
  },
  created() {

  },
  methods: {
    ...mapActions(['refreshUserBalance']),
    async submit() {
      if(this.isLoading) {
        return;
      }

      this.isLoading = true;

      try {
        const resp = await axios.post("/refill", { amount: this.amount });
        this.settings = resp.data;
        this.$toastr.s("Postage balance refilled!");
        this.amount = 0;
      } catch (e) {
        this.$toastr.e("Failed to refill postage balance");
      }

      this.refreshUserBalance()
      this.isLoading = false;
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/PostageRefill.vue